// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SNSj","rootMobile":"styles_rootMobile__3tbeY"};